// ADR 0062 §6.2: Jev's costs are kept in millionths of a dollar; people read dollars and cents.

const MICRO_USD_PER_DOLLAR = 1_000_000;
const MICRO_USD_PER_CENT = 10_000;
/** Under this many cents one decimal is shown ("4.8¢"); from here whole cents ("41¢"). */
const WHOLE_CENTS_FROM = 10;

export function microUsdOfDollars(dollars: number): number {
  return dollars * MICRO_USD_PER_DOLLAR;
}

/** "$1.31"; `decimals` 0 for round limits ("$25"). */
export function dollarsOf(microUsd: number, decimals = 2): string {
  return `$${(microUsd / MICRO_USD_PER_DOLLAR).toFixed(decimals)}`;
}

/** "4.8¢" for a small cost, dollars from a dollar up. */
export function centsOf(microUsd: number): string {
  if (microUsd >= MICRO_USD_PER_DOLLAR) return dollarsOf(microUsd);
  const cents = microUsd / MICRO_USD_PER_CENT;
  return `${cents.toFixed(cents >= WHOLE_CENTS_FROM ? 0 : 1)}¢`;
}
